import { useMemo } from 'react'

import { useDispatch } from 'react-redux'

import { showTransientNotification } from '@driftt/traffic-control'

interface INotifications {
  error: (message: string) => void
  success: (message: string) => void
}

const useNotifications = (): INotifications => {
  const dispatch = useDispatch()

  return useMemo(() => {
    const notificationDispatcher =
      (type: 'success' | 'error') => (message: string) =>
        dispatch(showTransientNotification({ type, message }))

    return {
      error: notificationDispatcher('error'),
      success: notificationDispatcher('success'),
    }
  }, [dispatch])
}

export default useNotifications
